export const EEMigrationLoginText = {
    registerNow: {
        english: `Register now.`,
        spanish: `Regístrate ahora.`,
    },
};
